import { useDayEventHandlers } from "./use-day-event-handlers";

export function useDayRender() {
	const eventHandlers = useDayEventHandlers();

	return {
		...eventHandlers,
	};
}
